module.exports = __webpack_public_path__ + "img/27341-049.c2f11770.jpg";